<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-absolute"
         :class="{'bg-white': showMenu, 'navbar-transparent': !showMenu}">
      <div class="container-fluid">
        <div class="navbar-wrapper">
          <div class="navbar-toggle d-inline" :class="{toggled: $sidebar.showSidebar}">
            <button type="button"
                    class="navbar-toggler"
                    @click="toggleSidebar">
              <span class="navbar-toggler-bar bar1"></span>
              <span class="navbar-toggler-bar bar2"></span>
              <span class="navbar-toggler-bar bar3"></span>
            </button>
          </div>
          <a class="navbar-brand" href="javascript:void(0)"> {{ $route.name }}</a>
        </div>
        <button class="navbar-toggler" type="button"
                @click="toggleMenu"
                data-toggle="collapse"
                data-target="#navigation"
                aria-expanded="false"
                aria-label="Toggle navigation">
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
        </button>
        <div class="collapse navbar-collapse show text-left" v-show="showMenu">
          <ul class="navbar-nav ml-auto">
            <drop-down>
              <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
                <div class="photo">
                  <img src="@/assets/img/anime3.png" alt="Profile Photo">
                </div>
                <b class="caret d-none d-lg-block d-xl-block"></b>
                <p class="d-lg-none">
                  Log out
                </p>
              </a>
              <ul class="dropdown-menu dropdown-navbar">
                <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">{{ user.name }}</a></li>
                <li class="dropdown-divider"></li>
                <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Profile</a></li>
                <li class="nav-link"><a href="javascript:void(0)" class="nav-item dropdown-item">Settings</a></li>
                <li class="dropdown-divider"></li>
                <li class="nav-link"><a v-on:click="leave" class="nav-item dropdown-item">Выход</a></li>
              </ul>
            </drop-down>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import DropDown from "@/components/Dropdown.vue";
import Modal from "@/components/Modal.vue";
import {
  SidebarPlugin
} from "@/components/index";
import {userService} from "@/services/user.service";

  export default{
    components:{
      DropDown,
      Modal,
      SidebarPlugin
    },
    data() {
      return {
        searchModalVisible: false,
        searchQuery: '',
        showMenu: false
      };
    },
    methods:{
      toggleSidebar(){
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      toggleMenu(){
        this.showMenu  = !this.showMenu;
      },
      leave(){
        userService.logout();
      }
    },
    computed:{
      isRTL: function() {
        return this.$rtl.isRTL;
      },
      user: function () {
        return userService.getUser();
      }
    }
  }
</script>
<style>
</style>
